module.exports = __webpack_public_path__ + "img/logo_instagram.7c1daf8e.png";